
export const CHART_LABELS = {
  
  axes: {
    yAxis: {
      numberOfAssets: 'Number of Assets',
    },
  },

  general: {
    assets: 'Assets',
    noData: 'No data available',
  },

  variants: {
    lifecycleStatus: 'Lifecycle Status',
    operatingStatus: 'Operating Status',
    assetAge: 'Asset Age',
  },

  lifecycle: {
    active: 'Active',
    classic: 'Classic',
    limited: 'Limited',
    obsolete: 'Obsolete',
  },

  operatingStatus: {
    planned: 'Planned',
    delivered: 'Delivered',
    standby: 'Standby',
    running: 'Running',
    decommissioned: 'Decommissioned',
  },

  assetAge: {
    zeroToTwo: '0–2 years',
    twoToFive: '2–5 years',
    fiveToTen: '5–10 years',
    tenPlus: '10+ years',
  },
} as const

export function getAssetCountLabel(count: number): string {
  return `${count} ${CHART_LABELS.general.assets}`
}

export function getYAxisLabel(): string {
  return CHART_LABELS.axes.yAxis.numberOfAssets
}

export default CHART_LABELS
